import type { SourcePack } from "@desk/core";

/** Immediate watermarked poster when WebGL/export capture fails (challenge Accept gate). */
export function buildSourceRecordPosterUrl(opts: {
  pack: SourcePack;
  scoreText?: string;
  width: number;
  height: number;
}): string {
  const { pack, scoreText, width, height } = opts;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return "";
  }
  ctx.fillStyle = "#142018";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "#f4faf3";
  ctx.font = "700 16px Syne, sans-serif";
  ctx.fillText("Source record", 16, 36);
  ctx.font = "500 13px Syne, sans-serif";
  wrap(ctx, pack.canonicalRecord.title, 16, 64, width - 32, 18);
  ctx.fillStyle = "rgba(244,250,243,0.75)";
  ctx.font = "12px IBM Plex Mono, monospace";
  ctx.fillText(scoreText ?? "Reach –", 16, height - 48);
  ctx.fillStyle = "rgba(11,18,32,0.7)";
  ctx.fillRect(12, height - 32, 72, 20);
  ctx.fillStyle = "#fff";
  ctx.font = "12px Syne, sans-serif";
  ctx.fillText(pack.exportSafety.requiredWatermark, 18, height - 18);
  try {
    return canvas.toDataURL("image/png");
  } catch {
    return "";
  }
}

function wrap(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  maxWidth: number,
  lineHeight: number,
): void {
  const words = text.split(/\s+/);
  let line = "";
  let row = 0;
  for (const word of words) {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      ctx.fillText(line, x, y + row * lineHeight);
      line = word;
      row += 1;
      if (row >= 4) break;
    } else {
      line = test;
    }
  }
  if (line && row < 4) ctx.fillText(line, x, y + row * lineHeight);
}
